
import { Vue, Component } from "vue-property-decorator";
import { formatDate, formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";
import { StockOrderResource } from "@/models/api/barcodeSystem/stockOrders/get";
import StockOrderReceiving from "@/components/barcodeSystem/stockOrder/StockOrderReceiving.vue"
import { ReceiveStockOrderRequest } from "@/models/api/barcodeSystem/stockOrders/receive";
import notifications from "@/lib/notifications";
const stockOrderModuleState = getModule(StockOrderModule);

@Component({
  components: {
    StockOrderReceiving
  }
})
export default class StockOrderHeader extends Vue {
  showReceiveOrderModal: boolean = false;
  showUnlockStockOrderPrompt: boolean = false;
  receivingLoading: boolean = false;
  unlockLoading: boolean = false;
  cancelLoading: boolean = false;
  showCancelStockOrderPrompt: boolean = false;
  receiveStockOrderRequest: ReceiveStockOrderRequest = null;
  receivingValidationMessages: string[] = null;
  
  get currentStockOrder(): StockOrderResource {
    return stockOrderModuleState.currentStockOrder;
  }

  get crn(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.crn
      : ""; 
  }  
  
  get locked(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.locked
      : ""; 
  }

  get companyName(): string {
    return stockOrderModuleState.currentStockOrder && stockOrderModuleState.currentStockOrder.company
      ? stockOrderModuleState.currentStockOrder.company.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.displayBillToCompanyId
      : ""; 
  }

  set displayBillToCompanyId(val: string){
  }

  get status(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.status
      : ""; 
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.statusDescription
      : ""; 
  }

  set statusDescription(val: string){
  }

  get shippingFacility(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.shippingFacility
      : ""; 
  }

  set shippingFacility(val: string){
  }

  get facilityCode(): string {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get shipDateFormatted(): string {
    return stockOrderModuleState.currentStockOrder
      ? formatDate(stockOrderModuleState.currentStockOrder.shipDate)
      : "";
  }

  set shipDateFormatted(val: string){
  }

  get anticipatedReceiveDateFormatted(): string{
    return stockOrderModuleState.currentStockOrder
      ? formatDate(stockOrderModuleState.currentStockOrder.anticipatedReceiveDate)
      : "";
  }

  set anticipatedReceiveDateFormatted(val: string){
  }

  get receivedDateTimeFormatted(): string{
    return stockOrderModuleState.currentStockOrder
      ? formatDateWithTime(stockOrderModuleState.currentStockOrder.receivedDate)
      : "";
  }

  set receivedDateTimeFormatted(val: string){
  }

  get requiresReceiving() : boolean
  {
    return stockOrderModuleState.currentStockOrder
      ? stockOrderModuleState.currentStockOrder.requiresReceiving
      : false;
  }

  
  get isReceiveable() : boolean
  {
    return this.receiveStockOrderRequest
      ? this.receiveStockOrderRequest.isReceiveable
      : false;
  }
  
  
  async receivePrompt()
  {
    this.receiveStockOrderRequest = null;
    this.receivingLoading = true;
    this.showReceiveOrderModal=true;
    this.receiveStockOrderRequest = await stockOrderModuleState.previewReceiveStockOrder(this.currentStockOrder.id);
    this.receivingLoading = false;
  }  
  
  promptForUnlockStockOrder()
  {
    this.showUnlockStockOrderPrompt = true;
  }
  
  promptForCancelStockOrder()
  {
    this.showCancelStockOrderPrompt = true;
  }

  closeModals()
  {
    this.showReceiveOrderModal=false;
    this.showUnlockStockOrderPrompt = false;
    this.showCancelStockOrderPrompt = false;
  }

  async receiveOrder() {
    if(this.validateReceiving())
    {
      this.receivingLoading = true;
      try {
        await stockOrderModuleState.receiveStockOrder(
          this.receiveStockOrderRequest
        );
        notifications.success("Stock Order Received", "Stock Order successfully received.");
        this.$emit("reload");
        this.closeModals();
      } catch (ex) {
        notifications.error("Receiving Stock Order", "Failed to receive stock orders", ex);
      } finally {
        this.receivingLoading = false;
      }
    }
  }
  
  async unlockStockOrder() {
    this.unlockLoading = true;
    try {
      await stockOrderModuleState.unlockStockOrder(
        stockOrderModuleState.currentStockOrder
      );
      notifications.success("Stock Order Unlocked", "Stock Order successfully unlocked.");
      this.$emit("reload");
      this.closeModals();
    } catch (ex) {
      notifications.error("Unlocking Stock Order", "Failed to unlock stock orders", ex);
    } finally {
      this.unlockLoading = false;
    }
  }
  
  async cancelStockOrder() {
    this.cancelLoading = true;
    try {
      await stockOrderModuleState.cancelStockOrder(
        stockOrderModuleState.currentStockOrder
      );
      notifications.success("Stock Order Cancelled", "Stock Order successfully cancelled.");
      this.$emit("reload");
      this.closeModals();
    } catch (ex) {
      notifications.error("Cancelling Stock Order", "Failed to cancel stock orders", ex);
    } finally {
      this.cancelLoading = false;
    }
  }
  
  validateReceiving() : boolean {
    let valid = this.receiveStockOrderRequest != null;
    this.receivingValidationMessages = null;

    if(!valid)
      return false;

    if(this.receiveStockOrderRequest.stockOrderItems.some(x => x.damaged && x.quantityDamaged <= 0)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.receivingValidationMessages = [];
      this.receivingValidationMessages.push('All damaged items must have a quantity damaged greater than 0.'); 
    }
    if(this.receiveStockOrderRequest.stockOrderItems.some(x => x.damaged && !x.damageCode)) {
      valid = false;
      if(!this.receivingValidationMessages)
        this.receivingValidationMessages = [];
      this.receivingValidationMessages.push('All damaged items must have a selected damage code.');
    }
    return valid;
  }
}

